import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import Loading from "./loading.js";
import { secretKey } from "./data";
import { downloadExcel } from "react-export-table-to-excel";

const MySwal = withReactContent(Swal2);

const ImportLead2 = (props) => {
  const [loading, setLoading] = useState(true);
  const [sources, setSources] = useState([]);
  const [array, setArray] = useState([]);
  const [arrayNon, setArrayNon] = useState([]);
  const [fileInfo, setFileInfo] = useState([]);

  const fileReader = new FileReader();

  const fetchLeadSources = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getLeadSources", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSources(data.filter((el) => el.name !== "Polecenie"));
        setLoading(false);
      })
      .catch((error) => {});
  };

  const fetchLeadsImport = async () => {
    var body = {
      leads: array,
    };

    await fetch("https://apisplit.ftpeople.pl/importLeads2", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Zaimportowano",
          text: "leady",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const getData = () => {
    fetchLeadSources();
  };

  useEffect(() => {
    setLoading(true);
    getData();
  }, []);

  const validate = () => {
    if (array.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const importLead = () => {
    if (validate()) {
      setLoading(true);
      fetchLeadsImport();
    } else {
      MySwal.fire({
        icon: "error",
        title: "Wgraj",
        text: "prawidłowy plik",
      }).then(async (result) => {});
    }
  };

  const checkSource = (source) => {
    var bool = false;
    sources.map((e) => {
      if (e.name === source) {
        bool = true;
      }
    });

    return bool;
  };

  const checkCompany = (company) => {
    var bool = false;
    props.companies.map((e) => {
      if (e.name === company) {
        bool = true;
      }
    });

    return bool;
  };

  const csvFileToArray = (string) => {
    const csvRows = string.slice(string.indexOf("\n") + 1).split("\n");

    const array1 = [];
    const arrayN = [];
    csvRows.map((i, index) => {
      const values = i.split(";");
      if (
        checkSource(!values[3] ? false : values[3].trim()) &&
        checkCompany(!values[6] ? false : values[6].trim())
      ) {
        var data = {
          name: values[0],
          phone: values[1],
          mail: values[2],
          source: values[3],
          sourceNote: values[4],
          sourceLink: values[5],
          company: values[6] ? values[6].trim() : "",
          idSource: values[7] ? values[7].trim() : "",
          aggr: values[8] ? values[8].trim() : "",
          distName: values[9] ? values[9].trim() : "",
        };
        array1.push(data);
      } else if (values.length !== 1) {
        var data = {
          name: values[0],
          phone: values[1],
          mail: values[2],
          source: values[3],
          sourceNote: values[4],
          sourceLink: values[5],
          company: values[6] ? values[6].trim() : "",
          idSource: values[7] ? values[7].trim() : "",
          aggr: values[8] ? values[8].trim() : "",
          distName: values[9] ? values[9].trim() : "",
        };
        arrayN.push(data);
      }
    });
    csvRows.map((i) => console.log(i.split(";")[3]));
    setFileInfo({
      rows: csvRows.filter(
        (i) => i.split(";")[3] !== undefined && i.split(";")[3] !== ""
      ).length,
      rowsAcc: array1.length,
    });
    setArray(array1);
    setArrayNon(arrayN);
    setLoading(false);
  };

  const readFile = (e) => {
    if (e.target.files[0]) {
      e.preventDefault();
      setLoading(true);

      if (e.target.files[0]) {
        fileReader.onload = function (event) {
          const text = event.target.result;
          csvFileToArray(text);
        };

        fileReader.readAsText(e.target.files[0], "Windows-1250");
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const createExcelDS = () => {
    var tab = [];
    arrayNon.map((el) => {
      tab.push([
        el.name,
        el.phone,
        el.mail,
        el.source,
        el.sourceNote,
        el.sourceLink,
        el.company,
        el.idSource,
        el.aggr,
      ]);
    });
    return tab;
  };

  const exportArrayNon = (e) => {
    var header = [
      "name",
      "phone",
      "mail",
      "source",
      "source note",
      "source link",
      "company",
      "id source",
      "umowa",
    ];
    downloadExcel({
      fileName: "importNon_report_" + new Date(),
      sheet: "data",
      tablePayload: {
        header,
        body: createExcelDS(),
      },
    });
  };

  return (
    <>
      <div
        style={{
          width: "50vw",
          borderRadius: "15px",
          boxShadow: "-8px 0px 24px 0px rgba(66, 68, 90, 1)",
          position: "fixed",
          right: "0",
          top: "15vh",
          backgroundColor: "white",
          padding: "2%",
          margin: "0px 10px",
          zIndex: "2",
        }}
      >
        {loading ? (
          <Loading />
        ) : (
          <>
            <div style={{ display: "flex", marginBottom: "3vh" }}>
              <div
                style={{
                  width: "85%",
                  textAlign: "left",
                  fontWeight: "600",
                  fontSize: "2vw",
                }}
              >
                IMPORTUJ LEADY
                <a
                  style={{ fontSize: ".8vw" }}
                  href="https://ftpeople.pl/wp-content/uploads/2025/08/lead_splitter_example-1-2.csv"
                >
                  (pobierz przykład)
                </a>
              </div>
              <div style={{ width: "15%" }}>
                <button
                  className="loginButtonLogin"
                  value="yes"
                  style={{
                    margin: "0",
                    backgroundColor: "navy",
                    borderColor: "navy",
                    width: "100%",
                  }}
                  onClick={props.close}
                >
                  X
                </button>
              </div>
            </div>
            <div style={{ display: "flex", gap: "50px" }}>
              <div style={{ width: "45%", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    paddingLeft: "20px",
                  }}
                >
                  plik <span style={{ color: "red" }}>*</span>
                </p>
                <input
                  type="file"
                  style={{
                    width: "100%",
                    padding: "0px 10px",
                    boxSizing: "border-box",
                    border: "none",
                  }}
                  onChange={readFile}
                />
              </div>
              <div
                style={{ width: "45%", textAlign: "left", fontSize: ".8vw" }}
              >
                Ilość rekordów: {fileInfo.rows ? fileInfo.rows : 0}
                <br />
                Ilość rekordów prawidłowych:{" "}
                {fileInfo.rowsAcc ? fileInfo.rowsAcc : 0}
                {arrayNon.length > 0 ? (
                  <>
                    <button
                      className="loginButtonLogin"
                      value="yes"
                      style={{
                        marginTop: "15px",
                        backgroundColor: "navy",
                        borderColor: "navy",
                        fontSize: ".5vw",
                        width: "50%",
                      }}
                      onClick={exportArrayNon}
                    >
                      POBIERZ NIEPRAWIDŁOWE - {arrayNon.length}
                    </button>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>

            <div style={{ marginTop: "50px", textAlign: "left" }}>
              <button
                className="loginButtonLogin"
                value="yes"
                style={{
                  margin: "0",
                  backgroundColor: "navy",
                  borderColor: "navy",
                }}
                onClick={importLead}
              >
                IMPORTUJ
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ImportLead2;
